import React, { useState, useEffect } from 'react';
import { instance2 } from '../../utils/axiosInstance';
import { ReactComponent as EditIcon } from "../../img/editicon.svg";
import { ReactComponent as TrashIcon } from "../../img/trashicon.svg";

import { ReactComponent as VerticalLine } from "../../img/verticalline.svg";
import { ReactComponent as MagnificationLogo } from "../../img/magnificationlensicon.svg";


export default function DapurTable() {
        const [searchQuery, setSearchQuery] = useState(""); // State for search input
  
  const [data, setData] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: '', direction: 'asc' });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await instance2.get("kitchen"); // Use instance2 for the API call
  
        setData(response.data); // Set data from Axios response
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
  
    fetchData();
  }, []);
  

  const handleSort = (key) => {
    const newDirection =
      sortConfig.key === key && sortConfig.direction === 'asc' ? 'desc' : 'asc';
    const sortedData = [...data].sort((a, b) => {
      if (a[key] < b[key]) return newDirection === 'asc' ? -1 : 1;
      if (a[key] > b[key]) return newDirection === 'asc' ? 1 : -1;
      return 0;
    });
    setData(sortedData);
    setSortConfig({ key, direction: newDirection });
  };

  const getSortArrow = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === 'asc' ? '▲' : '▼';
    }
    return '';
  };

  const filteredData = data.filter((item) => {
    const searchValue = searchQuery.toLowerCase();

    return (
      (item.location_name?.toLowerCase().includes(searchValue) || false) ||
      (item.kitchen_name?.toLowerCase().includes(searchValue) || false) 
    );
  });
  
      const [currentPage, setCurrentPage] = useState(1);
      const itemsPerPage = 5;
    
      // Calculate total pages
      const totalPages = Math.ceil(data.length / itemsPerPage);
    
      // Calculate the data to display on the current page
      const paginatedData = data.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
      );
    
      // Handle Page Navigation
      const handleNextPage = () => {
        if (currentPage < totalPages) {
          setCurrentPage((prevPage) => prevPage + 1);
        }
      };
    
      const handlePreviousPage = () => {
        if (currentPage > 1) {
          setCurrentPage((prevPage) => prevPage - 1);
        }
      };
  
    // Determine which page numbers to show
    let pageNumbers = [];
    const maxVisiblePages = 5;
  
    if (totalPages <= maxVisiblePages) {
      pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);
    } else {
      if (currentPage <= 3) {
        // Near the beginning
        pageNumbers = [1, 2, 3, 4, 5, "...", totalPages];
      } else if (currentPage >= totalPages - 2) {
        // Near the end
        pageNumbers = [1, "...", totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
      } else {
        // In the middle
        pageNumbers = [1, "...", currentPage - 1, currentPage, currentPage + 1, "...", totalPages];
      }
    }

  

  return (
    <div className="p-4">
      <h1 className="block text-black text-xl sm:text-2xl my-2 font-medium">Daftar Dapur</h1>

       {/* Search Bar */}
                <div className="flex py-4 rounded-[50px] flex-row justify-start items-center gap-2 w-full md:w-auto">
                  <div className="flex rounded-full p-2 bg-white text-gray-400 shadow-sm items-center w-full md:w-auto justify-start">
                    <MagnificationLogo />
                    <VerticalLine className="mx-1" />
                    <input
                      type="text"
                      placeholder="Telusuri data berdasarkan kategori, bahan baku, atau deskripsi"
                      className="flex-1 bg-transparent outline-none border-none text-gray-800 px-2 focus:outline-none focus:ring-none focus:ring-transparent text-sm"
                      style={{
                        width: `${"Telusuri data berdasarkan kategori, bahan baku, atau deskripsi".length}ch`,
                      }}
                      value={searchQuery} // Controlled input
                      onChange={(e) => setSearchQuery(e.target.value)} // Update search query
                    />
                  </div>
                </div>
      <table className="w-full border-collapse text-left">
        <thead>
          <tr className="bg-gray-100">
            <th
              className="border-b border-gray-300 px-4 py-2 cursor-pointer"
              onClick={() => handleSort('id')}
            >
              ID <span className="float-right">{getSortArrow('id')}</span>
            </th>
            <th
              className="border-b border-gray-300 px-4 py-2 cursor-pointer"
              onClick={() => handleSort('location_name')}
            >
              Koperasi{' '}
              <span className="float-right">{getSortArrow('location_name')}</span>
            </th>
            <th
              className="border-b border-gray-300 px-4 py-2 cursor-pointer"
              onClick={() => handleSort('kitchen_name')}
            >
              Nama Dapur{' '}
              <span className="float-right">{getSortArrow('kitchen_name')}</span>
            </th>
            <th
              className="border-b border-gray-300 px-4 py-2 cursor-pointer"
              onClick={() => handleSort('description')}
            >
              Deskripsi <span className="float-right">{getSortArrow('description')}</span>
            </th>
            <th
              className="border-b border-gray-300 px-4 py-2 cursor-pointer"
            >
            </th>
          </tr>asdsad
        </thead>
        <tbody>
          {filteredData.map((item, index) => (
            <tr
              key={item.id}
              className={`hover:bg-gray-100 ${
                item.id % 2 === 0 ? 'bg-gray-50' : 'bg-white'
              }`}
            >
              <td className="border-b border-gray-300 px-4 py-2">
              {index + 1 + (currentPage - 1) * itemsPerPage}</td>
              <td className="border-b border-gray-300 px-4 py-2">{item.location_name}</td>
              <td className="border-b border-gray-300 px-4 py-2">{item.kitchen_name}</td>
              <td className="border-b border-gray-300 px-4 py-2">{item.description}</td>
              <td className="border-b border-gray-300 px-4 py-2 text-center">
                    <div className="flex justify-center items-center gap-2">
                      <button
                        className="text-gray-500 p-2 rounded hover:bg-blue-400"
                        onClick={() => alert(`Edit data for ${item.location_name}`)}
                      >
                        <EditIcon className="w-5 h-5" />
                      </button>
                      <button
                        className="text-gray-500 p-2 rounded hover:bg-red-400"
                        onClick={() => alert(`Delete data for ${item.location_name}`)}
                      >
                        <TrashIcon className="w-5 h-5" />
                      </button>
                    </div>
                  </td>
            </tr>
          ))}
        </tbody>
      </table>

{/* Pagination Controls */}
<div className="flex justify-center items-center mt-4 text-xs sm:text-sm">
  {/* Previous Button */}
  <button
    className={`px-2 py-2 rounded ${
      currentPage === 1
        ? "text-gray-400 cursor-not-allowed"
        : "text-gray-500 hover:text-black"
    }`}
    onClick={handlePreviousPage}
    disabled={currentPage === 1}
  >
    <span className="font-bold text-lg sm:text-2xl">{"<"}</span>
  </button>

    {/* Page Numbers */}
    <div className="flex items-center">
        {pageNumbers.map((page, index) => (
          <span
            key={index}
            onClick={() => typeof page === "number" && setCurrentPage(page)}
            className={`mx-1 px-2 sm:px-3 py-1 cursor-pointer rounded-full ${
              currentPage === page ? "text-black font-semibold" : "text-gray-700"
            } ${page === "..." ? "cursor-default text-gray-400" : ""}`}
          >
            {page}
          </span>
        ))}
      </div>

  {/* Next Button */}
  <button
    className={`px-2 py-2 rounded ${
      currentPage === totalPages
        ? "text-gray-400 cursor-not-allowed"
        : "text-gray-500 hover:text-black"
    }`}
    onClick={handleNextPage}
    disabled={currentPage === totalPages}
  >
    <span className="font-bold text-lg sm:text-2xl">{">"}</span>
  </button>
</div>
    </div>
  

        );}